module.exports = __webpack_public_path__ + "static/media/grain.5cf6f493.svg";